"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isServer = isServer;
function isServer() {
  return typeof window === 'undefined';
}